/**
 * pages.config.js - Page routing configuration
 *
 * This file is AUTO-GENERATED. Do not add imports or modify PAGES manually.
 * Pages are auto-registered when you create files in the ./pages/ folder.
 *
 * THE ONLY EDITABLE VALUE: mainPage
 * This controls which page is the landing page (shown when users visit the app).
 *
 * Example file structure:
 *
 *   import HomePage from './pages/HomePage';
 *   import Dashboard from './pages/Dashboard';
 *   import Settings from './pages/Settings';
 *
 *   export const PAGES = {
 *       "HomePage": HomePage,
 *       "Dashboard": Dashboard,
 *       "Settings": Settings,
 *   }
 *
 *   export const pagesConfig = {
 *       mainPage: "HomePage",
 *       Pages: PAGES,
 *   };
 *
 * Example with Layout (wraps all pages):
 *
 *   import Home from './pages/Home';
 *   import Settings from './pages/Settings';
 *   import __Layout from './Layout.jsx';
 *
 *   export const PAGES = {
 *       "Home": Home,
 *       "Settings": Settings,
 *   }
 *
 *   export const pagesConfig = {
 *       mainPage: "Home",
 *       Pages: PAGES,
 *       Layout: __Layout,
 *   };
 *
 * To change the main page from HomePage to Dashboard, use find_replace:
 *   Old: mainPage: "HomePage",
 *   New: mainPage: "Dashboard",
 *
 * The mainPage value must match a key in the PAGES object exactly.
 */
import { lazy } from 'react';
import __Layout from './Layout.jsx';

function lazyWithRetry(importFn) {
  return lazy(() =>
    importFn().catch(() => {
      const reloaded = sessionStorage.getItem('chunk_reload');
      if (!reloaded) {
        sessionStorage.setItem('chunk_reload', '1');
        window.location.reload();
        return new Promise(() => {});
      }
      sessionStorage.removeItem('chunk_reload');
      return importFn();
    })
  );
}

const EventDetails = lazyWithRetry(() => import('./pages/EventDetails'));
const Dashboard = lazyWithRetry(() => import('./pages/Dashboard'));
const Events = lazyWithRetry(() => import('./pages/Events'));
const InviteResponse = lazyWithRetry(() => import('./pages/InviteResponse'));
const MyProfile = lazyWithRetry(() => import('./pages/MyProfile'));
const NotificationSettings = lazyWithRetry(() => import('./pages/NotificationSettings'));
const Staff = lazyWithRetry(() => import('./pages/Staff'));
const MyDocuments = lazyWithRetry(() => import('./pages/MyDocuments'));
const Documentation = lazyWithRetry(() => import('./pages/Documentation'));
const DocumentManagement = lazyWithRetry(() => import('./pages/DocumentManagement'));
const IhascoTraining = lazyWithRetry(() => import('./pages/IhascoTraining'));
const NotificationPreferences = lazyWithRetry(() => import('./pages/NotificationPreferences'));
const StaffProfile = lazyWithRetry(() => import('./pages/StaffProfile'));
const VerifyEmail = lazyWithRetry(() => import('./pages/VerifyEmail'));
const Admin = lazyWithRetry(() => import('./pages/Admin'));
const Flights = lazyWithRetry(() => import('./pages/Flights'));
const ClockInOut = lazyWithRetry(() => import('./pages/ClockInOut'));
const Notifications = lazyWithRetry(() => import('./pages/Notifications'));
const Tasks = lazyWithRetry(() => import('./pages/Tasks'));
// SKILLS_MATRIX_REMOVED: the old Skills Matrix route was removed; planning skills now live in Admin.
const MyAvailability = lazyWithRetry(() => import('./pages/MyAvailability'));
const Assistant = lazyWithRetry(() => import('./pages/Assistant'));


const UniformRequests = lazyWithRetry(() => import('./pages/UniformRequests'));
const FaultyEquipment = lazyWithRetry(() => import('./pages/FaultyEquipment'));

export const PAGES = {
    'faulty-equipment': FaultyEquipment,
    'uniform-requests': UniformRequests,
"event-details": EventDetails,
    "dashboard": Dashboard,
    "events": Events,
    "invite-response": InviteResponse,
    "profile": MyProfile,
    "notification-settings": NotificationSettings,
    "staff": Staff,
    "documents": MyDocuments,
    "document-management": DocumentManagement,
    "documentation": Documentation,
    "training": IhascoTraining,
    "notification-preferences": NotificationPreferences,
    "staff-profile": StaffProfile,
    "verify-email": VerifyEmail,
    "admin": Admin,
    "flights": Flights,
    "clock": ClockInOut,
    "notifications": Notifications,
    "tasks": Tasks,
    "availability": MyAvailability,
    "assistant": Assistant,
}

export const pagesConfig = {
    mainPage: "dashboard",
    Pages: PAGES,
    Layout: __Layout,
};
